import { IS_PROD } from '@variables';
var _ITERABLE_MARKETING_LIST_ID = IS_PROD
    ? 'dd3f792d-0e1b-4cc4-a05a-2f2acaca4ac3'
    : '000934be-868d-40f6-ab75-3234959c72bb';
export var addSubscriber = function (requestBody) {
    return fetch("//links.iterable.com/lists/publicAddSubscriberForm?publicIdString=".concat(_ITERABLE_MARKETING_LIST_ID), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: requestBody.email,
        }),
    });
};
